// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#home[data-v-559478d0] {\n  height: calc(100vh - 3.5rem);\n}\nimg.image[data-v-559478d0] {\n  width: 100px;\n  margin: 0 auto 20px;\n}", ""]);
// Exports
module.exports = exports;
